/* Scroll reveal animations — mirrors the Raylight site (ScrollReveal lib).
   Raylight config: origin top, distance 40px, duration 800, delay 100.
   We use origin 'bottom' (upward reveal) per the requested look, same timing. */
(function () {
  // Don't hide content while editing in the Shopify theme editor.
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var script = document.createElement('script');
  script.src = 'https://unpkg.com/scrollreveal';
  script.onload = function () {
    var sr = window.ScrollReveal({
      origin: 'bottom',
      distance: '40px',
      duration: 800,
      delay: 100,
      reset: false,
    });

    // Section-level blocks
    sr.reveal('.ch-hero__box, .ch-block__title');

    // Card groups, staggered like a sequence
    sr.reveal('.ch-cat', { interval: 100 });
    sr.reveal('.ch-product', { interval: 100 });
    sr.reveal('.ch-offer', { interval: 120 });
    sr.reveal('.ch-faq__row', { interval: 80 });
    sr.reveal('.ch-contact', {});
  };
  document.body.appendChild(script);
})();
